import { useState } from 'react';
import PropTypes from 'prop-types';
import { PROVIDERS } from 'Utils';
import IconSvg from 'Components/IconSvg';
import LoadingDots from 'Components/LoadingDots';

const LoginButton = ({
  autoSubmit,
  disabled,
  onClick,
  provider,
  text,
  type,
}) => {
  const [submitting, setSubmitting] = useState(false);
  const { key, title, darkLoader } = PROVIDERS[provider];
  const loading = autoSubmit || submitting;
  const handleClick = () => {
    setSubmitting(true);
    onClick();
  };

  return (
    <button
      id={key}
      // className will be .btn--icon or .btn--detail (for reference)
      className={`btn--${type} btn--${key}`}
      disabled={disabled || loading}
      key={key}
      onClick={handleClick}
    >
      {type === 'icon' &&
        (loading ? <LoadingDots dark={darkLoader} /> : <IconSvg type={key} />)}
      {type === 'detail' && (
        <div>
          <div className="btn__icon">
            <IconSvg type={key} />
          </div>
          {loading ? (
            <LoadingDots dark={darkLoader} />
          ) : (
            <span className="btn__text">
              {text.formatUimTranslation(title)}
            </span>
          )}
        </div>
      )}
    </button>
  );
};

LoginButton.propTypes = {
  autoSubmit: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  provider: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  type: PropTypes.string,
};

LoginButton.defaultProps = {
  autoSubmit: false,
  disabled: false,
  type: 'icon',
};

export default LoginButton;
